import React from "react";

const AccessDenied = () => {
    return (
        <div className="authincation h-50 p-meddle">
            <div className="container h-80">
                {" "}
                <div className="row justify-content-center h-50 align-items-center">
                    <div className="col-md-5">
                        <div className="form-input-content text-center error-page">

                            <h4>
                                <i className="fa fa-thumbs-down text-danger" /> Access Denied
                            </h4>
                            <p>Not allowed this page </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessDenied;
